import { Number, Record, Static, String, Undefined, Union } from "runtypes";

export const DirectorRequestRuntype = Record({
  email: String,
  schoolId: Number,
  firstName:String,
  lastName:String,
  coachId: Union(Number, Undefined),
  type: Union(String, Undefined)
});

export interface IDirectorRequest
  extends Static<typeof DirectorRequestRuntype> {}



// WEBPACK FOOTER //
// ./src/api/types/IDirectorRequest.ts